import { CUIColors, IconNames } from '@dotcom/crown-ui';
import userZoneAddPhotoIconUK from '../../assets/user-zone-add-photo-icon-uk.svg';
import userZoneAddTextIconUK from '../../assets/user-zone-add-text-icon-uk.svg';
import userZoneAddWamIconUK from '../../assets/user-zone-add-wam-icon-uk.svg';
import { DeliveryModes } from '../../components/address-form/address-form-types';
import { HeaderVariants } from '../../components/print-on-demand-header/print-on-demand-header-types';
import { RegionalCodesList } from '../../global-types';
import { TextEditorDrawerType } from '../../global-types/regions-list';
import colorsList from '../../styles/util.scss';
import { RegionalSchema } from '../regional-config-types';
import { buttons } from '../../themes/uk/buttons';

export const configUK: RegionalSchema = {
  deliveryMode: DeliveryModes.MailToRecipient,
  cardEditor: {
    faceTypeText: true,
    textEditorDrawerType: TextEditorDrawerType.Bottom,
    lastCardFaceRoute: 'preview',
  },
  cardSelectBar: {
    containerClass: 'footer',
  },
  addressForm: {
    handleZipChange: true,
    shouldShowOneToManyEnvelopePreview: false,
  },
  saveProjects: {
    isSavedProjectsEnabled: true,
    saveButton: {
      type: 'LoadingButton',
      iconName: IconNames.SyncSyncInactive,
    },
    hasSignInDialog: false,
  },
  header: {
    svgColor: CUIColors.Black,
    saveDialogTheme: RegionalCodesList.uk,
    variant: HeaderVariants.US,
    quantityInput: true,
  },
  scssStyles: {
    appBackground: colorsList[CUIColors.EditorBackground],
    headerBackgroundMobile: colorsList[CUIColors.White],
    'primary-button-background-color': buttons.primaryButtonBackgroundColor,
    'secondary-button-background-color': buttons.secondaryButtonBackgroundColor, // overrides crown-ui white
    'secondary-button-border-color': buttons.secondaryButtonBorderColor,
    'primary-button-disabled-border-color': buttons.primaryButtonDisabledBorderColor,
    'primary-button-disabled-background-color': buttons.primaryButtonDisabledBackgroundColor,
    'border-color': buttons.quickActionDeactivatedBorderColor,
  },
  features: {
    // POD Write a Message includes a WAM button in the toolbar and a WAM button in user zones
    isPodWamEnabled: true,
  },
  userZones: {
    addTextIcon: userZoneAddTextIconUK,
    addPhotoIcon: userZoneAddPhotoIconUK,
    addWAMIcon: userZoneAddWamIconUK,
    areInstructionsEnabled: true,
  },
  isAddressRegulationToastEnabled: false,
  hasUsStates: false,
  skipAddressView: true,
};
